import { State } from 'app/redux';

export const getSearches = (state: State) => state.inventory.searches;
